import { useMedicationConfigOverride } from '../contexts/DrugProgramProvider';
import { getFragment } from '../graphql/client/helpers/get-fragment';
import { processProviderToPharmacyInfo } from '../util';

import type { PrescriptionOffer } from './use-prescription-offers';

export const useProvidersFromOffers = (offers: PrescriptionOffer[]) => {
    const configOverride = useMedicationConfigOverride();

    return offers.map((offer) =>
        processProviderToPharmacyInfo(
            getFragment(offer.provider),
            configOverride
        )
    );
};
